// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import typeof { AnnouncementBar } from './AnnouncementBar'
import typeof * as Navigation from './navigation'

export const Header = ({
  children,
}: {
  children:
    | [
        ?React.Element<AnnouncementBar>,
        React.Element<$PropertyType<Navigation, 'Header'>>,
        React.Element<$PropertyType<Navigation, 'ExpandedMenu'>>
      ]
    | [
        React.Element<$PropertyType<Navigation, 'Header'>>,
        React.Element<$PropertyType<Navigation, 'ExpandedMenu'>>
      ],
}) => <HeaderRoot>{children}</HeaderRoot>

const HeaderRoot = styled<{ children: React.Node }>('div')`
  position: relative;
  // FIXME: Value set unreasonably high, because of other unreasonable uses of z-index in the codebase.
  z-index: 99999;
`
